import angular from 'angular';
import { IdentityService } from './IdentityService';
import { ifRole, ifExecutive, ifSuperadmin, ifPermitted, ifLoggedin, ifLoggedout } from './identityDirectives';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/taxonomy/taxonomyModule';
import 'components/sharpr/partnerLinks/partnerLinksModule.js';
import 'components/sharpr/auth/AuthModule';
import 'components/sharpr/cfg/cfgModule';
import 'components/sharpr/secureStorage/SecureStorageModule';

angular
	.module('sh.identity', ['sh.api', 'sh.taxonomy', 'sh.partnerLinks', 'sh.auth', 'sh.cfg', 'sh.secureStorage'])
	.service('Identity', IdentityService)
	.directive('shIfRole', ifRole) // <div sh-if-role="intel leader">
	.directive('shIfExecutive', ifExecutive) // <div sh-if-executive>
	.directive('shIfSuperadmin', ifSuperadmin) // <div sh-if-superadmin>
	.directive('shIfPermitted', ifPermitted) // <div sh-if-permitted="submit_post">
	.directive('shIfLoggedin', ifLoggedin) // <div sh-if-loggedin>
	.directive('shIfLoggedout', ifLoggedout); // <div sh-if-loggedout>
